import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'shared/services/User/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppComponent } from 'app/app.component';

@Component({
  selector: 'app-login-model',
  templateUrl: './login-model.component.html',
  styleUrls: ['./login-model.component.css']
})
export class LoginModelComponent implements OnInit {
  loginForm: FormGroup;
  createForm: FormGroup;
  loading: boolean;
  createNew: Boolean = false;
  disableLogin: Boolean = false;

  constructor(
    public dialogRef: MatDialogRef<LoginModelComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)])
    });

    this.createForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/)]),
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required])
    });
  }

  signInEmail() {
    this.disableLogin = true;
    this.markFormGroupTouch(this.loginForm);
    if (this.loginForm.valid) {
      // this.app.toggleLoadingMsg("Logging in")
      this.loading = true;
      this.userService.loginUserIframe(this.loginForm.value).then(res => {
        if (res) {
         /*  res.logged_in = true; */
          this.dialogRef.close(res);
        }
        this.disableLogin = false;
      }, err => { this.disableLogin = false; });
    }
  }

  createNewAccount() {
    this.disableLogin = true;
    const user = {
      firstName: this.createForm.value.firstName,
      lastName: this.createForm.value.lastName,
      email: this.createForm.value.email,
      password: this.createForm.value.password
    };
    this.userService.register(user).then(res => {
      /* res.logged_in = true; */
      /* res['logged_in'] = true; */
      this.dialogRef.close(res);
      this.disableLogin = false;
    }).catch(err => {
      this.disableLogin = false;
    });
  }

  toggle() {
    this.createNew = !this.createNew;
  }

  checkCreateForm() {
    return this.createForm.valid;
  }

  checkLoginForm() {
    return this.loginForm.valid;
  }

  private markFormGroupTouch(form: FormGroup) {
    (<any>Object).values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouch(control);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/widget/view-details/login-model/login-model.component.ts